import { useTranslation } from "react-i18next";
import ThresholdMap, { NEW_DB_TILE_BASE_PATH } from "../../maps/ThresholdMap";
import { Grid } from "@mantine/core";
import GrayScaleMap from "../../gray_scale_map/GrayScaleMap";

export default function FollowUpMaps(props) {
  const { t } = useTranslation();

  return (
    <Grid px={"md"}>
      <Grid.Col span={3}>
        <GrayScaleMap input={props.thresholds} testType={props.type} eye={props.eye} />
      </Grid.Col>
      <Grid.Col span={3}>
        <ThresholdMap
          thresholds={props.npdGs}
          testType={props.type}
          eye={props.eye}
          checkEmptyCells={true}
          content="probabilityTile"
          probabilityTileBasePath={NEW_DB_TILE_BASE_PATH}
        />
      </Grid.Col>
      <Grid.Col span={3}>
        <ThresholdMap
          thresholds={props.deviation}
          testType={props.type}
          checkEmptyCells={true}
          eye={props.eye}
        />
      </Grid.Col>
      <Grid.Col span={3} w={"100%"} display={"flex"}>
        <div>
          {props.meanDeviation < -20 ? (
            <div className={"depressed-field-warning"}>{t("severely_depressed_field_warning")}</div>
          ) : (
            <ThresholdMap
              thresholds={props.progressionAnalysis}
              testType={props.type}
              eye={props.eye}
              checkEmptyCells={true}
              content="probabilityTile"
              probabilityTileBasePath="img/gpa_images/{img}.png"
            />
          )}
        </div>
      </Grid.Col>
    </Grid>
  );
}
